<template>
    <div id="invoiceDetail" v-if="details">
        <AppBreadCrumb
            :paths="[{ title: $t('billing.invoiceManagement'), path: '/billing' }, { title: 'Fatura Detay' }]"
            :select="true"
        />
        <div class="invoice-detail-content">
            <div class="invoice">
                <div class="invoice-head" style="margin-bottom: 20px">
                    <div class="row-item">
                        <div class="column-item">
                            <div class="title">{{ $t("billing.site") }}</div>
                            <div class="content">{{ siteName }}</div>
                        </div>
                        <div class="column-item">
                            <div class="title">{{ $t("billing.period") }}</div>
                            <div class="content">{{ details.period }}</div>
                        </div>
                        <div class="column-item" style="width: 30%">
                            <div class="title">{{ $t("billing.billStatus") }}</div>
                            <div class="content">{{ details.paid ? $t("billing.paid") : $t("billing.unPaid") }}</div>
                        </div>
                    </div>
                    <div
                        :class="
                            (invoice.type === 'manuel' || invoice.isManuel) && invoice.description
                                ? 'row-item-space-between'
                                : 'row-item-end'
                        "
                    >
                        <div class="column-item" v-if="invoice.description">
                            <div class="title">{{ $t("message.description") }}</div>
                            <div class="content">{{ invoice.description }}</div>
                        </div>
                        <div class="column-item">
                            <div class="title">{{ $t("billing.totalPrice") }}</div>
                            <div class="content">{{ ~~(invoice.price || 0) }}₺</div>
                        </div>
                    </div>
                </div>

                <div class="invoice-head" style="margin-bottom: 20px" v-if="details.plans.length > 0">
                    <div class="row-item">
                        <div class="column-item">
                            <div class="title">{{ $t("instagram.detail") }}</div>
                        </div>
                    </div>
                </div>
                <div class="details" v-if="details.plans.length > 0">
                    <div class="detail-content" v-for="planGroup of details.plans">
                        <div class="head">
                            <div class="title">
                                {{ planGroup.title }}
                            </div>
                            <div class="price" v-if="planGroup.price > 0">{{ ~~(planGroup.price || 0) }}₺</div>
                        </div>
                        <div class="content">
                            <div class="detail-content-child" v-for="item of planGroup.items">
                                <div class="head">
                                    <div class="title">
                                        <span>
                                            -
                                            <b
                                                >{{ item.title }}
                                                {{
                                                    item.planType === "storage"
                                                        ? `(${item.details.exceededSpace.toFixed(2)}GB)`
                                                        : ""
                                                }}
                                                {{
                                                    item.planType === "automation"
                                                        ? isFreePlan(item)
                                                            ? `(Free Plan)`
                                                            : `(${getSelectedCount(item)} Tasks)`
                                                        : ""
                                                }}
                                                {{
                                                    item.planType === "supsis"
                                                        ? `(${item.details.agentCount} Agent) ${
                                                              item.details.freeAgentCount
                                                                  ? `(+${item.details.freeAgentCount} Ücretsiz)`
                                                                  : ""
                                                          }`
                                                        : [
                                                              "whatsapp-business",
                                                              "whatsapp",
                                                              "instagram",
                                                              "messenger",
                                                              "trendyol",
                                                          ].includes(item.planType)
                                                        ? `(${item.details.channelCount} Kanal)`
                                                        : item.planType === "chatbot"
                                                        ? `(${item.details.totalChatbotSessionCount} Chatbot)`
                                                        : ""
                                                }}
                                                {{
                                                    item.planType === "mail"
                                                        ? isFreePlan(item)
                                                            ? `(Free Plan)`
                                                            : `(${getSelectedCount(item)} Mail)`
                                                        : ""
                                                }}
                                            </b>
                                        </span>
                                        {{ item.startDate ? `${item.startDate} - ${item.endDate}` : "" }}
                                    </div>
                                    <div class="price" v-if="item.price > 0">{{ item.price }}₺</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { getDetailInvoice } from "./utils/util";
import _ from "lodash";

const { getInvoiceById } = require("../../../api/billing");

export default {
    name: "InvoiceDetail",
    components: { AppBreadCrumb },
    data() {
        return {
            siteName: "",
            invoice: {},
            details: {
                paid: false,
                period: "",
                plans: [],
            },
        };
    },
    watch: {},
    methods: {
        isFreePlan(item) {
            const price = _.get(item, "details.selectedFeature.price", 0);
            return price === 0 || item.isFreePlan;
        },
        getSelectedCount(item) {
            return _.get(item, "details.selectedFeature.count", 0);
        },
    },
    mounted() {
        getInvoiceById(this.$route.params.id).then((data) => {
            this.invoice = data.invoice;
            this.siteName = data.siteName;
            this.details = getDetailInvoice(data.invoice);
        });
    },
};
</script>
<style lang="scss" scoped>
#invoiceDetail {
    .invoice-detail-content {
        background: white;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .invoice {
        width: 85vw;
        height: 100vh;
        border: 1px solid #c7d0d7;
        margin-top: 10px;
    }

    .top-head {
        display: flex;
        align-items: top;
        justify-content: space-between;
        margin-top: 10px;

        img {
            width: 200px;
            height: 80px;
        }

        .info {
            display: flex;
            flex-direction: column;
            align-items: end;
            font-weight: bold;
            font-size: 14px;
        }
    }

    .invoice-head {
        padding: 20px 30px;
        background: #f1f4f7;

        .row-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &-end {
                display: flex;
                align-items: center;
                justify-content: flex-end !important;
                margin-top: 20px;
            }
            &-space-between {
                display: flex;
                align-items: center;
                justify-content: space-between !important;
                margin-top: 20px;
            }
        }

        .title {
            font-size: 16px;
        }

        .content {
            font-size: 16px;
            font-weight: 500;
        }
    }

    .details {
        display: flex;
        flex-direction: column;
        justify-content: start;
        padding: 30px;
        padding-top: 0;

        .detail-content {
            user-select: none;
            margin-top: 4px;

            &-child {
                .head {
                    background: none !important;
                    color: black !important;
                    border: none !important;

                    .title {
                        font-weight: normal !important;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        span {
                            font-weight: 400 !important;
                        }
                    }

                    .price {
                        font-weight: lighter !important;
                        font-size: 12px;
                    }
                }
            }

            .head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: black;
                background: #f1f4f7;
                padding: 4px 12px;

                .title {
                    font-weight: bold;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: black;
                        font-weight: bold;
                        margin-right: 10px;
                    }
                }

                .price {
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
